import React, { useEffect, useState } from 'react';
import { ThemeProvider } from 'styled-components';
import { Theme as TTheme} from '../contexts/operator/operator-context';
import useOperatorContext from '../contexts/operator/useOperatorContext';
import {iLog} from "../index";


// the default theme is there prior to any operator theme..

const defaultTheme = {
    v4:
        {
            favicon: null,
            logo: null,
            hero: null,
            hero_2: null,
            bg_tile: null,

            primary_font_name: null,
            primary_font_spacing: '0.5px',
            primary_font_case: 'none',
            primary_font_regular: null,
            primary_font_bold: null,
            primary_font_italic: null,
            primary_font_bold_italic: null,
            secondary_font_name: null,
            secondary_font_spacing: '0.5px',
            secondary_font_case: 'none',
            secondary_font_regular: null,
            secondary_font_bold: null,
            secondary_font_italic: null,
            secondary_font_bold_italic: null,

            navigation_style: 'pill',
            card_style: 'landscape',
            card_shadow: 'flat',

            xl_radius: '12px',
            l_radius: '8px',
            m_radius: '8px',
            s_radius: '4px',

            layout_1: '#000000',
            layout_2: '#ffffff',
            layout_3: '#fafafa',
            layout_4: '#fafafa',
            layout_5: '#fafafa',
            layout_6: '#fafafa',
            layout_7: '#fafafa',
            layout_8: '#ffffff',
            layout_9: '#fafafa',
            layout_2_border: '#ffffff',
            layout_2_border_width: '1px',
            layout_3_border: '#ffffff',
            layout_3_border_width: '1px',
            layout_4_type: 'color',
            layout_5_type: 'color',
            layout_6_type: 'color',
            layout_7_type: 'color',
            layout_8_border: '#fafafa',
            layout_9_type: 'color',
            ui_1: '#000000',
            ui_2: '#ffffff',
            ui_3: '#f3f3f3',
            ui_4: '#000000',
            ui_5: '#000000',
            ui_6: '#000000',
            ui_7: '#ffffff',
            ui_8: '#f3f3f3',
            ui_9: '#ffffff',
            ui_10: '#000000',
            ui_11: '#ffffff',
            ui_12: '#f3f3f3',
            ui_13: '#000000',
            ui_14: '#000000',
            ui_15: '#000000',
            ui_16: '#000000',
            ui_17: '#FFFFFF',
            ui_18: '#000000',
            ui_19: '#FFFFFF',
            ui_20: '#F3F3F3',
            ui_21: '#000000',
            ui_22: '#FFFFFF',
            ui_23: '#F3F3F3',
            card_border: '1px',
            navigation_border: '1px',
            underline_border: '1px',
            primary_cta_border: '1px',
            text_xl_header: '#000000',
            text_l_header: '#000000',
            text_m_header: '#000000',
            text_s_header: '#000000',
            text_l_body: '#000000',
            text_m_body: '#8e8e93',

            cookie_banner: false,
            allergens_advice: false,
            allergens_advice_onsite: false,
            preferences_modal: false,
            location_search: false,
            address_autocomplete_delivery: false,
            address_autocomplete_catering: false,
            customer_notes: false,
            upsell: false,
            tipping_collection: false,
            tipping_delivery: false,
            tipping_catering: false,
            tipping_venues: false,
            tipping_dine_in: false,
            remember_me: true,
            remember_me_default: true,

            slogan: null,
            allergen_info: null,
            allergen_info_onsite: null,
            cookie_banner_text: null,
            opt_in: null,
            opt_in_default: false,
            catering_label: null,

            custom_css: null,
        }
};

type PageProps = {
    children: JSX.Element;
};

const Theme = ({children}: PageProps) => {
    const operatorContext = useOperatorContext();
    const [theme, setTheme] = useState<TTheme>(defaultTheme);

    useEffect(() => {
        if (operatorContext.operator) {

            let operator_theme = operatorContext.operator?.theme;

            let obj = {
                ...defaultTheme,
                ...operator_theme,
            };

            setTheme(obj);
        }
    }, [ operatorContext ]);

    return <ThemeProvider theme={theme}>{children}</ThemeProvider>;
};

export default Theme;
